export const FormError = (props: { error?: string; errorId: string; className: string; data_cy?: string }) => {
  const { error, errorId, className, data_cy } = props;
  if (!error) return null;
  return (
    <span id={errorId} className={className} data-cy={data_cy} data-testid={data_cy} role="alert">
      {error}
    </span>
  );
};
